import { FC, useState, useMemo, useEffect, useCallback } from "react";
import { CurrentBranchContext } from "./CurrentBranchContext";
import { branchService } from "../../../_services/branch.service";
import { configService } from "../../../_services/config.service";

const CurrentBranchProvider: FC = ({ children }) => {
  const [currentBranch, setCurrentBranch] = useState<string>(
    configService.getCurrentBranch(),
  );
  const [favouriteFloor, setFavouriteFloor] = useState<string | null>(null);

  const onUpdateBranch = useCallback((id: string) => {
    configService.refreshCurrentBranch(id);
    setCurrentBranch(id);
  }, []);

  const onUpdateFavouriteFloor = useCallback((id: string | null) => {
    setFavouriteFloor(id);
    if (id) {
      configService.makeFloorFavorite(id);
    }
  }, []);

  useEffect(() => {
    const loadConfig = async () => {
      const config = await configService.get();

      // Validate and set current branch
      const branchReferences = await branchService.getReferences();
      const validBranch = branchReferences?.find(
        (branch) => branch.id === config.currentBranch,
      );

      if (validBranch) {
        onUpdateBranch(config.currentBranch);
      } else if (branchReferences.length > 0) {
        // Use first available branch if stored one is not valid
        const firstBranch = branchReferences[0];
        onUpdateBranch(firstBranch.id);
      }

      // Set favourite floor
      if (config.favouriteFloor) {
        setFavouriteFloor(config.favouriteFloor);
      }
    };
    loadConfig();
  }, [onUpdateBranch]);

  const value = useMemo(
    () => ({
      currentBranch,
      favouriteFloor,
      onUpdateBranch,
      onUpdateFavouriteFloor,
    }),
    [currentBranch, favouriteFloor, onUpdateBranch, onUpdateFavouriteFloor],
  );

  return (
    <CurrentBranchContext.Provider value={value}>
      {currentBranch && children}
    </CurrentBranchContext.Provider>
  );
};

export default CurrentBranchProvider;
